import { useState, useEffect } from "react"
import QuestionNumber from "./partials/QuestionNumber";
import QuestionContainer from "./partials/QuestionContainer";
import { STATIC_STRINGS } from "@asez/shared";
import { qWiseReportAPI } from "../Services";
import RenderLoading from "./partials/RenderLoading";
import RenderError from "../partials/RenderError";
import useDataFetch, { DataFetchOptionsType } from "../../../hooks/useDataFetch";

function QuestionWiseReport() {

  const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({});
      const { loading, data, error } = useDataFetch(qWiseReportAPI, fetchOptions);
  
      useEffect(() => {
      setFetchOptions({ requestId: new Date().getTime().toString() });
      }, []);
  
      if (loading) {
      return <RenderLoading/>;
      }
      if (error) {
      return (
          <RenderError
          error={error}
          onRetry={() => {
              setFetchOptions({
              loading: true,
              });
              setTimeout(() => {
              setFetchOptions({ requestId: new Date().getTime().toString() });
              }, 1000);
          }}
          />
      );
      }

  return (
    <div className="w-full">
      {data.questions.map((question, index) => (
        <div key={index} className="mb-8 border-l-4 border-neutral rounded-lg px-2">
          < QuestionNumber question={question} index={index}/>
          <div className="flex flex-col md:flex-row gap-6">
      
            <div className="md:w-3/5">
              <QuestionContainer question={question}/>
            </div>
            
            <div className="md:w-2/5">
              <div className="border-l-4 border-neutral pl-4 rounded-lg">
                <h3 className="text-xl font-semibold mb-2">{STATIC_STRINGS.QUESTION_WISE_REPORT_ENUM.FEEDBACK}</h3>
                <p className="text-gray-700">{question.feedback}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default QuestionWiseReport;
